// A policy's capital as the calculation reports it: a number, a numeric string, or absent on
// rows from the advice and transfer services. A known amount, zero included, is shown as is;
// an absent or unreadable one is unknown.
export const knownCapital = (value: unknown): number | undefined => {
  if (value === undefined || value === null || value === "") return undefined;
  const capital = Number(value);
  return Number.isFinite(capital) && capital >= 0 ? capital : undefined;
};
